import React from "react";
import { Navigate, Route, createRoutesFromElements } from "react-router-dom";

//Layouts
import DueDatesLayout from "../layout/DueDatesLayout";
import SettingsLayout from "../layout/SettingsLayout";
import SimpleLayout from "../layout/SimpleLayout";

//DueDates pages
import { AllTasksPage } from "../pages/BoardViews/AllTasks";
import { AssignedToMe } from "../pages/BoardViews/AssignedToMe";
import { CompletedTasks } from "../pages/BoardViews/CompletedTasks";
import { CustomView } from "../pages/BoardViews/CustomView";
import { OverDueTasks } from "../pages/BoardViews/OverdueTasks";

//Settings pages
import { BoardsList } from "../pages/Settings/BoardsList";
import { Permissions } from "../pages/Settings/Permissions";
import { TaskTypesLayout } from "../pages/Settings/TaskTypesLayout";

// Error Pages
import { InternalServerError } from "../pages/Error/InternalServerError";
import { InvalidAccess } from "../pages/Error/InvalidAccess";
import { InvalidLicense } from "../pages/Error/InvalidLicense";
import { NotFound } from "../pages/Error/PageNotFound";
import { Unauthorized } from "../pages/Error/Unauthorized";

//Task types pages
import { TaskTypeDetails } from "../pages/Settings/TaskTypeDetails";

//Welcome page
import NotificationsLayout from "../layout/NotificationsLayout";
import { FavoriteView } from "../pages/BoardViews/FavoriteView";
import { MyCompletedTasks } from "../pages/BoardViews/MyCompletedTasks";
import { RelatedToMe } from "../pages/BoardViews/RelatedToMe";
import { InvalidBoardAccess } from "../pages/Error/InvalidBoardAccess";
import { BoardPermissionRequests } from "../pages/Manage/BoardPermissionRequests";
import { NotificationPreferences } from "../pages/Settings/NotificationPreferences";
import { SystemPreferences } from "../pages/Settings/SystemPreferences";
import { default as WelcomePage } from "../pages/Welcome/WelcomePage";

const createDueDatesRoutes = (prefix = "") => {
  const basePath = prefix ? `${prefix}duedates/` : "duedates/";

  return (
    <React.Fragment key={prefix}>
      <Route path={prefix}>
        <Route
          index
          element={<Navigate to={`${basePath}views/assignedtome`} />}
        />
        <Route path="manage" element={<SimpleLayout pre={prefix} />}>
          <Route
            path="board-permission-requests"
            element={<BoardPermissionRequests />}
          />
        </Route>
        <Route path="duedates" element={<DueDatesLayout pre={prefix} />}>
          <Route
            path="views/alltasks" // For backward compatibility with bookmarks
            element={<AllTasksPage pre={prefix} />}
          />
          <Route
            path="views/activetasks"
            element={<AllTasksPage pre={prefix} />}
          />
          <Route
            path="views/assignedtome"
            element={<AssignedToMe pre={prefix} />}
          />
          <Route
            path="views/relatedtome"
            element={<RelatedToMe pre={prefix} />}
          />
          <Route
            path="views/completedtasks"
            element={<CompletedTasks pre={prefix} />}
          />
          <Route
            path="views/overduetasks"
            element={<OverDueTasks pre={prefix} />}
          />
          <Route
            path="views/mycompletedtasks"
            element={<MyCompletedTasks pre={prefix} />}
          />
          <Route
            path="views/favorites/:viewId"
            element={<FavoriteView pre={prefix} />}
          />
          <Route path="views/:viewId" element={<CustomView pre={prefix} />} />
          <Route
            index
            element={<Navigate to={`${basePath}views/assignedtome`} />}
          />
        </Route>
      </Route>
    </React.Fragment>
  );
};

const createSettingsRoutes = (prefix = "") => {
  const basePath = prefix ? `${prefix}duedates/` : "duedates/";

  return (
    <React.Fragment key={`${prefix}-settings`}>
      <Route path={prefix}>
        <Route
          path="duedates/settings"
          element={<SettingsLayout pre={prefix} />}
        >
          <Route path="boards" element={<BoardsList pre={prefix} />} />
          <Route path="permissions" element={<Permissions pre={prefix} />} />
          <Route
            path="boards/:boardId"
            element={<TaskTypesLayout pre={prefix} />}
          >
            <Route
              path="tasktypes/:taskTypeId"
              element={<TaskTypeDetails pre={prefix} />}
            />
          </Route>
          <Route
            path="SystemPreferences"
            element={<SystemPreferences pre={prefix} />}
          />

          <Route
            index
            element={<Navigate to={`${basePath}settings/boards`} />}
          />
        </Route>
        <Route
          path="duedates/notifications"
          element={<NotificationsLayout pre={prefix} />}
        >
          <Route
            path="notificationpreferences"
            element={<NotificationPreferences pre={prefix} />}
          />
        </Route>
      </Route>
    </React.Fragment>
  );
};

export const routes = createRoutesFromElements(
  <>
    {createDueDatesRoutes()}
    {createDueDatesRoutes("app/")}
    {createSettingsRoutes()}
    {createSettingsRoutes("app/")}

    {/* Error handling routes with shared layout */}
    <Route path="duedates" element={<SimpleLayout />}>
      <Route path="500" element={<InternalServerError />} />
      <Route path="404" element={<NotFound />} />
      <Route path="401" exact element={<Unauthorized />} />
      <Route path="403" element={<InvalidAccess />} />
      <Route path="invalidlicense" element={<InvalidLicense />} />
      <Route path="invalid-board-access" element={<InvalidBoardAccess />} />
      <Route path="welcome" element={<WelcomePage key="welcome" />} />
    </Route>

    <Route
      path="*"
      element={<Navigate to="/app/duedates/views/assignedtome" />}
    />
  </>
);
